import { useAtomValue } from 'jotai';

import { scheduledPatientInformationAtom } from '../schedule-preview/state';
import { selectedClientInfoAtom } from '../state';

/**
 * Resolves appointment and patient short IDs for the selected client, matching
 * the pre-visit summary card's ID resolution.
 */
export function useSelectedClientAppointmentIds() {
  const selectedPatientInfo = useAtomValue(selectedClientInfoAtom);
  const scheduledPatientInfo = useAtomValue(scheduledPatientInformationAtom);

  const appointmentShortId =
    selectedPatientInfo?.inSessionAppointmentShortId || scheduledPatientInfo?.appointmentShortId;
  const patientShortId = selectedPatientInfo?.patientShortId || scheduledPatientInfo?.patientShortId || '';

  return { appointmentShortId, patientShortId };
}
